/* eslint-disable no-console */

import {
    register
} from "register-service-worker";

if (process.env.NODE_ENV === "production") {
    var refreshing;
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                "App is being served from cache by a service worker.\n" +
                "For more details, visit https://goo.gl/AFskqB"
            );
        },
        registered() {
            console.log("Service worker has been registered.");
        },
        cached() {
            /* window.alert("Страница грузится из кеша"); */
            console.log("Content has been cached for offline use.");
        },
        updatefound() {
            /* window.alert("Загружаем новую версию"); */
            console.log("New content is downloading.");
        },
        updated() {
            /*  window.alert("Доступна новая версия! Обновите кеш браузера"); */
            console.log("New content is available; please refresh.");
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
        },
        offline() {
            console.log(
                "No internet connection found. App is running in offline mode."
            );
        },
        error(error) {
            /*  window.alert(error); */
            console.error("Error during service worker registration:", error);
        }
    });
}